module.exports = __webpack_public_path__ + "static/media/back-arrow-grey.72011ae3.svg";